import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { API } from '../../api';
import { addLoading, removeError, removeLoading } from './index';
import types from '../types';

export default function getArticleOptions(
  id: string
): ThunkAction<Promise<void>, StoreRoot, unknown, AnyAction> {
  return async (dispatch) => {
    const entry = 'getArticleOptions';

    dispatch(removeError(entry));
    dispatch(addLoading(entry));

    return API.restaurantApi
      .getArticleOptions(id)
      .then((res) => {
        dispatch({
          type: types.SET_ARTICLE_OPTIONS,
          payload: res.data,
        });
      })
      .catch((err) => console.log('Error is', err.message))
      .finally(() => dispatch(removeLoading(entry)));
  };
}
